<template>
  <PopUpModal ref="popup">
    <!-- ------------ -->
    <!--  container   -->
    <!-- ------------ -->
    <div class="container-fluid">
      <div class="col p-3">
        <!-- ------------------ -->
        <!--  row 1 = heading   -->
        <!-- ------------------ -->
        <div
          class="row bb-sub-hdg mt-1 mb-3 justify-content-center text-center"
        >
          {{ title }} [{{ row.name }}]
        </div>
        <!-- ------------------- -->
        <!--  row 2 = bleeding   -->
        <!-- ------------------- -->
        <div class="row mb-2">
          <CounterImageComponent
            :pass_ref="'counter_bleeding'"
            :pass_image="bleed_image"
            :pass_count="bleed_cnt"
            :pass_min="minBleedCount"
            :pass_max="maxBleedCount"
          />
        </div>
        <!-- ------------------ -->
        <!--  row 3 = buttons   -->
        <!-- ------------------ -->
        <div class="row mt-3 mb-3">
          <!-- ------------ -->
          <!--    buttons   -->
          <!-- ------------ -->
          <div class="btn-group special" role="group">
            <!-- ------------ -->
            <!--    cancel    -->
            <!-- ------------ -->
            <button
              type="submit"
              @click="_cancel"
              class="btn btn-lg btn-warning"
            >
              Cancel
            </button>
            <!-- ------------ -->
            <!--      OK      -->
            <!-- ------------ -->
            <button
              type="submit"
              @click="_confirm"
              class="btn btn-lg btn-primary"
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- </div> -->
  </PopUpModal>
</template>
<script>
import CounterImageComponent from "./CounterImage.vue";
import capitaliseFirstLetter from "../helpers/capitaliseFirstLetter";
import getMarkerImage from "../helpers/getMarkerImage";
import PopUpModal from "./PopUpModal.vue";

// import sleep from "../helpers/sleep";

export default {
  name: "BleedingDialog",
  components: {
    PopUpModal,
    CounterImageComponent,
  },
  //=====================================================================
  // data
  //------
  data: () => ({
    bleed_cnt: 0,
    minBleedCount: 0,
    maxBleedCount: 0,
    bleed_image: null,
    title: undefined,
    row: undefined,
    okButton: "OK",
    cancelButton: "Cancel",
    resolvePromise: undefined,
    rejectPromise: undefined,
  }),
  //=====================================================================
  // methods
  //---------
  methods: {
    ucSlotName(slotname) {
      return capitaliseFirstLetter(slotname);
    },
    show(opts = {}) {
      //-------------
      // load values
      //-------------
      this.title = opts.title;
      this.row = opts.row;
      this.bleed_cnt = this.row["bleeding"];
      this.minBleedCount = opts.minBleedCount;
      this.maxBleedCount = opts.maxBleedCount;
      //---------------------
      // load bleeding image
      //---------------------
      this.bleed_image = getMarkerImage("bleeding");
      //-------------------------------------
      // set listener from counter component
      //-------------------------------------
      this.emitter.on("counter_bleeding", (return_count) => {
        this.bleed_cnt = return_count;
      });
      //-------------
      // open dialog
      //-------------
      this.$refs.popup.open();
      //
      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve;
        this.rejectPromise = reject;
      });
    },
    //=====================================================================
    // confirm
    //---------
    _confirm() {
      this.$refs.popup.close();
      this.resolvePromise(this.bleed_cnt);
    },
    //=====================================================================
    // cancel
    //--------
    _cancel() {
      this.$refs.popup.close();
      this.resolvePromise();
    },
  },
};
</script>